import { render, staticRenderFns } from "./GeneralScopeofWorkSheet.vue?vue&type=template&id=06a97670&scoped=true"
import script from "./GeneralScopeofWorkSheet.vue?vue&type=script&lang=ts"
export * from "./GeneralScopeofWorkSheet.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a97670",
  null
  
)

export default component.exports